// packages import
import { FC, useContext } from 'react'

// component imports
import AttorneyDropdown from '../../../common/AttorneyDropdown'

// others
import { Maybe, User } from '../../../../../generated'
import { PreBillsContext } from '../../../../context'

const AttorneyFilter: FC = () => {
  const { filters, setFilters } = useContext(PreBillsContext)

  const handleAttorneyChange = (value: Maybe<User>) => {
    setFilters({ attorneyId: value?.id })
  }

  return (
    <AttorneyDropdown
      selectedAttorneyId={filters.attorneyId}
      onChange={handleAttorneyChange}
      label="Attorney"
      sx={{ minWidth: 150 }}
    />
  )
}

export default AttorneyFilter
